<template>
  <div class="block paragraph" :class="{ odd }">
    <div class="body" v-html="body" />
  </div>
</template>

<script>
  export default {
    name: 'BlockParagraph',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      content: {
        type: Object,
        default: null,
      },
      odd: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      body() {
        return this.content?.body || null;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.block.paragraph {
  display: flex;
  justify-content: center;

  & > .body {
    max-width: calc(50% - 20px);
    min-width: 550px;
    margin-bottom: 60px;

    @include screen-mobile {
      min-width: 100%;
    }

    p {
      margin: 20px 0;
      &:first-of-type { margin-top: 0; }
      &:last-of-type { margin-bottom: 0 }
    }
  }
}
</style>
